<template>
  <div class="circle-wrp" :class="[`circle-style__${color}`]">
    <div class="circle1 circle"></div>
    <div class="circle2 circle"></div>
    <div class="circle3 circle"></div>
    <div class="circle4 circle"></div>
    <div class="circle5 circle"></div>
    <div class="circle6 circle"></div>
    <div class="circle7 circle"></div>
    <div class="circle8 circle"></div>
    <div class="circle9 circle"></div>
    <div class="circle10 circle"></div>
    <div class="circle11 circle"></div>
    <div class="circle12 circle"></div>
  </div>
</template>
<script setup lang="ts">
withDefaults(
  defineProps<{
    color?: 'black' | 'white';
  }>(),
  {
    color: 'white',
  },
);
</script>

<style lang="scss" scoped>
.circle-wrp {
  margin: 0 7px 0 0;
  float: left;
  width: 15px;
  height: 15px;
  position: relative;
}

.circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.circle-style__white .circle:before {
  background-color: var(--color-white);
}

.circle-style__black .circle:before {
  background-color: var(--color-black);
}

.circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 2px;
  height: 2px;
  border-radius: 100%;
  animation: circleFadeDelay 1.2s infinite ease-in-out both;
}

.circle2 {
  transform: rotate(30deg);
}

.circle3 {
  transform: rotate(60deg);
}

.circle4 {
  transform: rotate(90deg);
}

.circle5 {
  transform: rotate(120deg);
}

.circle6 {
  transform: rotate(150deg);
}

.circle7 {
  transform: rotate(180deg);
}

.circle8 {
  transform: rotate(210deg);
}

.circle9 {
  transform: rotate(240deg);
}

.circle10 {
  transform: rotate(270deg);
}

.circle11 {
  transform: rotate(300deg);
}

.circle12 {
  transform: rotate(330deg);
}

.circle2:before {
  animation-delay: -1.1s;
}

.circle3:before {
  animation-delay: -1s;
}

.circle4:before {
  animation-delay: -0.9s;
}

.circle5:before {
  animation-delay: -0.8s;
}

.circle6:before {
  animation-delay: -0.7s;
}

.circle7:before {
  animation-delay: -0.6s;
}

.circle8:before {
  animation-delay: -0.5s;
}

.circle9:before {
  animation-delay: -0.4s;
}

.circle10:before {
  animation-delay: -0.3s;
}

.circle11:before {
  animation-delay: -0.2s;
}

.circle12:before {
  animation-delay: -0.1s;
}

@-webkit-keyframes circleFadeDelay {
  0%, 39%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

@keyframes circleFadeDelay {
  0%, 39%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
</style>
